import React, { useContext } from "react";
import { observer } from "mobx-react";

import { OfferStoreContext } from "@gp/components";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

import { StreakStatsBody } from ".";

export const StreaksStatistics = observer(function StreaksStatistics() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	if (store.displayStatisticsGroup === StatisticsGroups.StreakStats) {
		return <StreakStatsBody store={store} />;
	}

	return null;
});
